import React from 'react';
import {Link} from '../Link/Link';
import {styled} from '@mui/material/styles';

import type {LinkProps} from '../Link/Link';

export interface FooterLinkProps extends LinkProps {
    /**
     * Link text
     */
    text?: string;
}

const StyledLink = styled(Link)<LinkProps>(({theme}) => ({
    color: theme.tokens.FuelColorGray800,
    textDecorationColor: theme.tokens.FuelColorGray800,
    fontSize: theme.tokens.FuelFontSizeSm,
    paddingLeft: '0.25rem',
    paddingRight: '0.25rem',
    width: '100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',

    '&.Mui-focusVisible': {
        boxShadow: `0 0 0 2px ${theme.tokens.FuelColorGray200}, 0 0 0 4px #1b1b1b`
    }
}));

export const FooterLink = React.forwardRef<any, FooterLinkProps>(({
    text, ...props
}, ref): React.ReactElement => (
    <StyledLink
        ref={ref}
        {...props}
    >{text}</StyledLink>
));

FooterLink.displayName = 'FooterLink';
